<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading">
      <div class="edit-cont">
        <div class="edit-text">For editing your DoveMed profile, please visit your profile.</div>
        <!-- <div class="edit-text">Edit additional information on your DoveMed clinic’s profile.</div> -->
        <a-button class="profile-btn" @click="GotoPhyProfile()">Visit Profile</a-button>
      </div>

      <div v-if="profileData['about'] && profileData['about'].length" class="about-cont">
        <div class="header">About the clinic</div>
        <div class="bio">{{ profileData["about"] }}</div>
      </div>

      <div class="pad" v-if="profileData.ext_ref_id" :style="{ 'margin-bottom': '80px' }">
        <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" :avgRating="parseFloat(profileData.overall_rating || '0')" />
      </div>

      <div class="pad" v-if="profileData.ext_ref_id" :style="{ 'margin-bottom': '80px' }">
        <DoctorAboutRecommend :refId="profileData.ext_ref_id" :IsOwnerView="true" />
      </div>

      <div v-if="profileData['specialities'] && profileData['specialities'].length" class="about-cont">
        <div class="header">Speciality {{ profileData["specialities"] | total }}</div>
        <div class="speciality-cont">
          <div class="speciality" v-for="item in profileData['specialities']" :key="item.speciality.id">
            <div class="cont">
              <img class="speciality-icon" v-if="item.speciality.icon" :src="item.speciality.icon" />
              <div class="speciality-text">{{ item.speciality.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="profileData['clinical_services'] && profileData['clinical_services'].length" class="about-cont">
        <div class="header">
          Clinical Services
          {{ profileData["clinical_services"] | total }}
        </div>
        <div v-for="(service, ind) in profileData['clinical_services']" :key="ind" class="service-card-cont">
          <div class="service-header">
            <a-avatar :style="{ display: 'flex', 'align-items': 'center', 'justify-content': 'center', background: '#F1F5F9', padding: '15px' }" :size="70" :src="service[0].image"> </a-avatar>
            <!-- <img :src="service.image" /> -->
            <div class="sub-header">{{ service[0].clinicclinicalservicebranch }}</div>
          </div>
          <div class="service-details">
            <ul>
              <li class="services" v-for="item in service[0].sub_branches" :key="item.id">
                {{ item.clinicclinicalservicesubbranch }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="about-cont" v-if="profileData['affiliated_physicians'] && profileData['affiliated_physicians'].length > 0">
        <div class="header">Affiliated Physicians {{ profileData["affiliated_physicians"] | total }}</div>
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-3" :style="{ 'padding-right': '0px', 'padding-left': '0px' }" v-for="(item, index) in profileData['affiliated_physicians']" :key="index">
          <div class="claim-card">
            <div class="user-name d-flex p-3">
              <div class="d-flex flex-column">
                <a class="bg-img d-block background-image">
                  <a-avatar :style="{ color: ' #ffffff !important', 'background-color': '#C997C5' }" :size="70" :src="item.physician_profile_info.picture" class="text-capitalize">
                    {{ item.physician_profile_info.full_name[0] }}
                  </a-avatar>
                </a>
                <div class="rating-cont">
                  <div class="review-star">
                    <ReviewStar :rating="item.physician_profile_info.overall_rating" />
                  </div>
                  <span class="rating-text">{{ item.physician_profile_info.overall_rating }} stars</span>
                  <span class="rating-text">{{ item.physician_profile_info.no_of_reviews }} reviews</span>
                </div>
              </div>
              <hr class="divider" />
              <div class="right-items">
                <div class="text-left align-self-center overflow-hidden first-cont">
                  <div class="tags-cont">
                    <div class="rec-tag">
                      <font-awesome-icon size="2x" style="transform: scale(0.5); width: 24px; height: 24px; color: #906eff" :icon="['fas', 'thumbs-up']" />
                      <div>Recommended</div>
                    </div>
                    <div class="crown-tag">
                      <font-awesome-icon size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: #f5a623" :icon="['fas', 'crown']" />
                    </div>
                  </div>
                  <div class="bold-text cp" :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '20px', 'line-height': '30px' }">
                    {{ item.physician_profile_info.full_name }}
                  </div>
                  <div class="tag">
                    <div class="tag-ele rounded" :style="{ background: getPrimary50Color() }">
                      <p :style="{ color: getPrimaryColor(), 'font-weight': '700', 'font-size': '12px', 'line-height': '14px' }" class="m-0 doc-loc text-truncate">
                        {{ item.physician_profile_info.physician_speciality }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="meet-others">
                  <div class="card-address">
                    <div class="card-number">
                      <img src="../../../assets/images/addphy-phone.png" alt="phone-logo" />
                      <div><strong>000000000</strong></div>
                    </div>
                    <div class="card-location">
                      <img src="../../../assets/images/addphy-location.png" alt="location" />
                      <div class="location-complete">
                        <span class="location-fix" :style="{ color: '#94A3B8' }">
                          {{ item.physician_profile_info.address.city ? item.physician_profile_info.address.city : "" }}
                          {{ item.physician_profile_info.address.state ? "," + item.physician_profile_info.address.state : "" }}
                          {{
                            item.physician_profile_info.address.street
                              .split(" ")
                              .filter(sttr => sttr !== "None,")
                              .join(" ")
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="card-distance">
                      <div :style="{ 'margin-top': '12px' }"><strong>0 miles away</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="profileData.affiliated_ohcps && profileData.affiliated_ohcps.length > 0" class="about-cont">
        <div class="header">Affiliated Advanced Medical Professionals ({{ profileData.affiliated_ohcps.length }})</div>
        <div class="w-100" v-for="(card, index) in profileData.affiliated_ohcps" :key="index">
          <AffiliatedCard :item="card.ohcp_info" :type="'hcp'" :info="card" />
        </div>
      </div>

      <!-- <div class="dovemed-card" v-if="cardKey === 'educational_qualifications'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div :header="itemKey" :key="ItemIndex">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <p v-if="nestItemValue">
                {{ nestItemKey | humanize(false) }}: {{ nestItemValue }}
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'board_certifications'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div :header="itemKey" :key="ItemIndex">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'state_licensure'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card">
              <p v-if="item.license_number">
                <b>License Number:</b> {{ item.license_number }}
              </p>
              <p><b>State:</b> {{ item.state }}</p>
              <p>
                <b>Status:</b>
                <span>{{ item.is_active ? "Active" : "Inactive" }}</span>
              </p>
              <p v-if="item.issue_date">
                <b>Affiliation Date:</b> <span>{{ item.issue_date }}</span>
              </p>
              <p v-if="item.expire_date">
                <b>Expiry Date:</b> <span>{{ item.expire_date }}</span>
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'academic_affiliations'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card">
              <p>
                <b>Name of Organization:</b> {{ item.name_of_organization }}
              </p>
              <p>
                <b>Affiliation:</b>
                <span>{{
                  item.currently_affiliated ? "Affiliated" : "Not Affiliated"
                }}</span>
              </p>
              <p v-if="item.from_date">
                <b>Affiliation Date:</b> <span>{{ item.from_date }}</span>
              </p>
              <p v-if="item.to_date">
                <b>Expiry Date:</b> <span>{{ item.to_date }}</span>
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'medical_school'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div v-if="item.university" class="dovemed-card">
              <p v-if="item.degrees"><b>Degree:</b> {{ item.degrees }}</p>
              <p v-if="item.year_of_completion">
                <b>{{ "year_of_completion" | humanize(false) }}:</b>
                {{ item.year_of_completion }}
              </p>
              <p v-if="item.academic_awards">
                <b>Academic Awards:</b> {{ item.academic_awards }}
              </p>
              <p v-if="item.university">
                <b>University:</b> {{ item.university.name }}
              </p>
              <p v-if="item.city"><b>City:</b> {{ item.city }}</p>
              <p v-if="item.state"><b>State:</b> {{ item.state }}</p>
              <p v-if="item.country"><b>Country:</b> {{ item.country.name }}</p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'residency'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'chief_residency'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'other_education'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img
                v-if="nestItemKey === 'imagge'"
                :src="nestItemValue"
                alt=""
              />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'internship'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'fellowship'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div v-for="(cardValue, cardKey, index) in cardKeys" :key="index"> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'about'">
        <div style="display: flex; justify-content: space-between">
          <p class="title">{{ cardKey | humanize }}</p>
        </div>
        <p v-if="!cardValue">{{ profileData[cardKey] }}</p>
        <a-textarea
          v-model="profileData[cardKey]"
          :rows="4"
          v-if="cardValue"
          class="editable-textarea"
        />
        <button
          class="dovemed-button primary-border font-primary ml-4"
          v-if="cardValue"
          @click="save(cardKey)"
        >
          Save
        </button>
        <button
          class="dovemed-button primary-border font-primary ml-4"
          v-if="cardValue"
          @click="cancelEditable(cardKey)"
        >
          Cancel
        </button>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'language_spoken'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div class="language">
          <div
            v-for="(language, index) in profileData[cardKey]"
            :key="index"
            class="mono-language"
          >
            <img :src="language.icon" />
            <p>{{ language.language }}</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'intrested_areas'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div class="language">
          <div
            v-for="(area, index) in profileData[cardKey]"
            :key="index"
            class="mono-language"
          >
            <img :src="area.icon" />
            <p>{{ area.name }}</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'conditions_treated'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div>
          <ul>
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              <a
                :style="item.link && { color: '#0e72ba !important' }"
                class="ml-2"
                target="_blank"
                :href="item.link"
                >{{ item.condition }}</a
              >
            </li>
          </ul>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'procedures_performed'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div>
          <ul>
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              <a
                class="ml-2"
                :style="item.link && { color: '#0e72ba !important' }"
                target="_blank"
                :href="item.link"
                >{{ item.procedure }}</a
              >
            </li>
          </ul>
        </div>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'accepted_insurance'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div>
          <ul>
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              {{ item.carrier }}
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import ReviewStar from "../../Users/Doctor/reviewstarforcircle.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faThumbsUp, faCrown } from "@fortawesome/pro-solid-svg-icons"
library.add(faThumbsUp, faCrown)
import DoctorAboutRecommend from "./view/DoctorAboutRecommend.vue"
import DoctorAboutReview from "./view/DoctorAboutReview.vue"
import AffiliatedCard from "../../home/provider/AffiliatedCard.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "Clinic_Profile",
  components: {
    DoctorAboutRecommend,
    DoctorAboutReview,
    ReviewStar,
    AffiliatedCard,
  },
  data() {
    return {
      cardKeys: null,
      profileData: null,
      toDeleteKeys: [
        "id",
        "created_at",
        "updated_at",
        "is_deleted",
        "user",
        "is_verified",
        "npi_number",
        "state_licence",
        "licence_number",
        "display_name",
        "rec_description",
        "rec_option",
        "rec_user",
        "rec_user_circle",
        "recommendations",
        "user_circle",
      ],
      // test: null
      status: false,
      loading: true,
    }
  },
  created() {
    console.warn("ClinicProfile.vue created")
    this.fetchData()
  },

  methods: {
    /**
     * Fetch user profile data
     */
    async fetchData() {
      this.loading = true
      const data = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
      this.profileData = data.data.data ? data.data.data[0] : {}
      this.loading = false
      let profileDataCopy = { ...this.profileData }
      this.toDeleteKeys.forEach(key => {
        delete profileDataCopy[key]
      })
      // const keys = Object.keys(profileDataCopy)
      const keys = Object.keys(profileDataCopy)
      this.cardKeys = this.makeKeys(keys)
      this.status = true
      console.log("fetchData() -> profileData:", this.profileData)
    },

    GotoPhyProfile() {
      window.open(`${process.env.SSO_BASE_URL}/ratings/clinic/${this.authUser.user.ext_ref_id}-${this.authUser.user.first_name}-${this.authUser.user.last_name.split(" ").join("-")}`, "_blank")
    },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },
  },

  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
.services::marker {
  color: #2a71d4;
  font-size: 150%;
}

.services {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.service-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 24px;
}

.service-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
}

.service-card-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 16px;
  gap: 16px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.bio {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
  text-align: justify;
}

.header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  width: 100%;
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}

.edit-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f !important;
  text-align: center;
}

.edit-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 16px;
  background: #f1f5f9;
  margin-bottom: 80px;
}

.pad {
  padding: 24px;

  @media screen and (max-width: 900px) {
    padding: 0px;
  }
}

.about-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  margin-bottom: 80px;

  @media screen and (max-width: 900px) {
    padding: 0px;
  }
}

.profile-btn {
  padding: 8px 16px;
  background: #062b54;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.crown-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  width: 30px;
  height: 22px;
  background: #fff0d6;
  border-radius: 4px;
  justify-content: center;
}

.tags-cont {
  display: flex;
  gap: 8px;
}

.rec-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  width: 115px;
  height: 22px;
  background: #f1edff;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #906eff;
}

.recommended-title {
  margin-top: 48px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #0f1734;
}

.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }
}

.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;
  padding-left: 16px;

  input {
    border: none !important;
  }
}

.search-input-state {
  background: none;
  border-left: 0 !important;
  height: 60px;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;

  &:focus {
    outline: none;
  }
}

.search-button {
  max-width: 60px;
  min-width: 60px;
  border-radius: 8px;
  border: none;
  height: 60px;
  background-color: #f1f5f9 !important;

  &:focus {
    outline: none;
  }
}

// card
.claim-card {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

  .user-name {
    height: 178px;
    padding: 24px !important;

    @media screen and (max-width: 900px) {
      height: 100%;
    }

    .rating-text {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      /* or 117% */

      text-align: center;

      /* Gray/900 */

      color: #0f1734;
    }

    .rating-cont {
      margin-top: 11px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px;
      gap: 4px;
      margin-left: 5px;
      width: 88.53px;
      height: 48px;
    }

    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 70px;
      max-height: 70px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: inline-block;
      margin-left: 11.5px;
      margin-right: 35.5px;

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}
.divider-mob {
  display: none;
  @media screen and (max-width: 900px) {
    height: inherit;
    border: 1px solid #cbd5e1;
    margin-top: -24px;
    background: #cbd5e1;
  }
}

.divider {
  height: 178px;
  border: 1px solid #cbd5e1;
  margin-top: -24px;
  background: #cbd5e1;

  @media screen and (max-width: 900px) {
    height: inherit;
    position: absolute;
    left: 150px;
  }
}

.first-cont {
  width: 294px;
  display: flex;
  flex-direction: column;
  gap: 17px;
  @media screen and (max-width: 900px) {
    width: 158px;
  }
}

.right-items {
  display: flex;
  width: 100%;
  // justify-content: space-between;
  gap: 24px;
  overflow: none !important;
  margin-left: 24px;
  font-size: 14px;

  @media screen and (max-width: 900px) {
    display: block;
    width: 158px;
    margin-left: 20px;
  }
}

.meet-others {
  display: flex;
  align-items: center;
  width: 283px;

  @media screen and (max-width: 700px) {
    width: 158px;
  }

  button {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
  }
}

.dovemed-button {
  padding: 12px 45px;
}

.linkbutton {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 8px;
  height: 46px;

  .link-text {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}

.card-number {
  display: flex;
  flex-direction: row;
  align-items: end;
  padding: 0px;
  gap: 6px;
  width: 126px;
  height: 24px;

  p {
    margin-bottom: 0;
    margin-left: 0.03px;
    color: #0f1734 !important;
  }
}

.card-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 152px;
  // height: 42px;
  margin-top: 13.5px;
  gap: 6px;
}
.location-fix {
  display: flex;
  max-width: 152px;
  flex-wrap: wrap;
  word-break: break-all;
}
.location-complete {
  // height: 42px;

  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-top: 7px;
  @media screen and (max-width: 700px) {
    height: 100%;
  }
}

.location-complete p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-bottom: 0;
  align-items: start;
  display: flex;
  margin-left: 8.5px;
}

.card-distance {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 0px 28px;
  // height: 21px;
  // margin-top: 12px;
  display: flex;
  align-items: start;
}

.tag {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;

  .tag-ele {
    padding: 4px 8px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    margin-right: 5px;
    // height: 22px;
  }
}

.review-title {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #0f1734;
  margin-bottom: 0px;
}

.review-ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 33.5px;
  margin-top: 28px;
}

.speciality-icon {
  width: 22.8px;
  height: 24px;
}

.speciality-text {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #1e2945;
  display: contents;
}

.cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  // width: 91px;
  height: 62px;
}

.speciality {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  gap: 16px;
  width: 100%;
  height: 110px;
  background: #f1f5f9;
  border-radius: 6px;
}

.speciality-cont {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  // padding: 24px;
  gap: 16px;
  border-radius: 6px;
  width: 100%;
  flex-wrap: wrap;
}

.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  img {
    border-radius: 0.5em;
    max-width: 150px;
    max-height: 150px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  ul {
    list-style: none;
    /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    margin-left: 20px;
  }

  .mono-language {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin: 1em 0;

    img {
      width: 2em;
    }

    p {
      margin-left: 1em;
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/ClinicProfile.vue